import {forwardRef, useEffect, useRef, useState} from 'react';

import { GroupedVirtuoso, VirtuosoGrid } from 'react-virtuoso';
import Loading from '../components/helper/loading';
import getPortfolio from '../api/getPortfolio';
import { Portfolio } from '../globalValues';

import Popup from '../components/popup';

type Entry = {
  list: Portfolio[],
  groups: string[],
  groupCounts: number[]
}

interface Preview {
  name: string,
  thumbnail: string,
  url: string
}

export default function PortfolioPage() {

    const virtuosoRef = useRef<any>(null);

    const [loading, setLoading] = useState<boolean>(true);
    const [portfolioList, setPortfolioList] = useState<Entry>();

    // Popup
    const [isOpen, setIsOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState<Preview>({name: "", url: "", thumbnail: ""});

    async function getPort() {
        try {
            setLoading(true);
            const res: Portfolio[] | undefined = await getPortfolio();

            const groups = res!.map(item => item.type).filter((value, index, self) => self.indexOf(value) === index)

            const groupCounts = groups.map((letter) => {
                return res!.filter((entry) => entry.type === letter).length
            });

            setPortfolioList({list: res!, groups: groups, groupCounts: groupCounts});            
            setLoading(false);

        }
        catch(e) {
            console.log(e);
        }
    }

    function displayFullImage(name: string, thumbnail: string, url: string) {
        setIsOpen(true); 
        setPreviewImage({name: name, thumbnail: thumbnail, url: url}); 

        let ex = document.getElementById("html");
        ex?.classList.add("overflow-y-hidden");     
    }

    function closePreview() {
        setIsOpen(false); 
        setPreviewImage({name: "", thumbnail: "", url: ""}); 

        let ex = document.getElementById("html");
        ex?.classList.remove("overflow-y-hidden");
    }


    useEffect(() => {
        // Fetch the list of images for the gallery
        getPort();
    }, []);


    if(loading) {
        return(
            <div className="bg-wrapper">
                <div className="gallery-wrapper">
                    <Loading />
                </div>
            </div>
        );
    }
    else {
        return (
            <div>
                {isOpen === true && 
                    <Popup 
                        type={"portfolio"}
                        name={previewImage.name}
                        thumbnail={previewImage.thumbnail}
                        url={previewImage.url}
                        closePreview={closePreview}
                    />
                }
                <h1 className="text-center">PORTFOLIO</h1>

                <div className="gallery-wrapper">
                    {portfolioList !== null && portfolioList !== undefined && 
                        <VirtuosoGrid
                            ref={virtuosoRef}
                            useWindowScroll
                            style={{height: "100%"}}
                            components={gridComponents}
                            data={portfolioList.list}
                            totalCount={portfolioList.list.length}
                            increaseViewportBy={{ top: 210, bottom: 420 }}
                            itemContent={(index, entry) => {
                            return(
                                <ItemWrapper>
                                    <div key={"portfolio-" + index} >                    
                                        <img src={entry.thumbnail} alt="" className="lore-wallpaper-image" loading='lazy'/>
                                    </div>
                                </ItemWrapper>
                            );                                      
                            }}
                        />

                    }
                </div>
            </div>
        );
    }
}


const ItemWrapper = ({ children, ...props }: any) => (
  <div
    {...props}
    className="wallpaper-grid-sub"
  >
    {children}
  </div>
)

// For the Virtual Grid
const gridComponents = {
  List: forwardRef(({ style, children, ...props }: any, ref: any) => (
    <div
      ref={ref}
      {...props}
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        ...style,
      }}
    >
      {children}
    </div>
  )),

  Item: ({ children, ...props }: any) => (
    <div
      {...props}
      className="wallpaper-grid-item"
    >
      {children}
    </div>
  )
}